import { LoadingScreen } from '@/features/common/components/LoadingScreen';
import { NotFound } from '@/features/common/components/NotFound';
import { useCurrentAccount } from '@/hooks/useCurrentAccount';
import { Account } from '@/models/account.model';
import { Outlet } from 'react-router-dom';

export default function AccountRoute() {
  /**
   * * If account exists, return an outlet that will render needed view
   * * If not, return NotFound component
   */
  const { currentAccount, isLoading } = useCurrentAccount<Account | null>();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!currentAccount) {
    return <NotFound />;
  }

  return <Outlet />;
}
